import React, { useRef } from "react";

import { Link } from "widgets/navigation";

import { BaseTopNav } from "./components/base_topnav/index.jsx";
import { AccountLogo } from "./components/account_logo/index.jsx";
import { Help } from "./components/help/index.jsx";
import { UserProfile } from "./components/user_profile/index.jsx";

import styles from "./topnav.css";

import LogoIcon from "./icons/logo.svg";

export function CommonTopnav() {
  const currentClosePopup = useRef(null);

  return (
    <BaseTopNav>
      <BaseTopNav.LeftRenderer>
        <div className={styles.logoContainer}>
          <Link route={"/"}>
            <LogoIcon width={32} height={32} />
          </Link>
        </div>
        <div id="navmenucontainer">
          <div className={styles.navgroups} />
        </div>
      </BaseTopNav.LeftRenderer>
      <BaseTopNav.RightRenderer>
        <div className={styles.rightColumn}>
          <div
            id="workflowupgradenavcontainer"
            className={styles.upgradenavcontainer}
          />
          <div id="searchnavcontainer" className={styles.searchnav} />
          <Help />
          <div id="notificationavcontainer" className={styles.notificationav} />
          {/** will be used for showing upgrade buttong */}
          <div
            id="upgradenavcontainer"
            className={styles.upgradenavcontainer}
          />
          <AccountLogo />
          <UserProfile currentClosePopup={currentClosePopup} />
        </div>
      </BaseTopNav.RightRenderer>
    </BaseTopNav>
  );
}
